// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"info-page_bannerContainer__rowJm","bgImg":"info-page_bgImg__UIbdp","wrapper":"info-page_wrapper__rbd3u"};